export default "__VITE_ASSET__27b80564__"